import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpXsrfTokenExtractor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './../services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class SecurityInterceptor implements HttpInterceptor {
  constructor(private xsrfTokenExtractor: HttpXsrfTokenExtractor, private authService: AuthService) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let xsrfToken = this.xsrfTokenExtractor.getToken() as string;
    if (request.method === 'POST') {
      if (!xsrfToken || xsrfToken == null) {
        return this.authService.getCSRFToken()
          .pipe(
            switchMap((data: any) => {
              xsrfToken = data.token;
              request = request.clone({ headers: request.headers.set('X-XSRF-TOKEN', xsrfToken) });
              return next.handle(request);
            })
          );

      } else {
        return next.handle(request);
      }
    }
    else {
      return next.handle(request);
    }
  }
  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   // load token
  // this.xsrfTokenExtractor.getToken() as string;
  //   if (xsrfToken != null && req.method === 'POST') {
  //     const authorizedRequest = req.clone({
  //       withCredentials: true,
  //       headers: req.headers.set('X-XSRF-TOKEN', xsrfToken)
  //     });
  //     return next.handle(authorizedRequest);
  //   } else {
  //     return next.handle(req);
  //   }
  // }
}
